module.exports = __webpack_public_path__ + "img/152-b09ba1.png";